"use client";
import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { BASE_URL } from "../config/config";

const SubscribedUserContext = createContext();

export const useSubscribedUsers = () => useContext(SubscribedUserContext);

export const SubscribedUserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");
  /* ================= FETCH USERS ================= */
  const fetchUsers = useCallback(async () => {
    if (!token) return; // don't fetch if no token

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/subscribed-users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // send token
        },
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        setUsers(data.data || []);
      } else {
        console.error("Failed to fetch users:", data.message || data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  /* ================= UPDATE STATUS ================= */
  const updateUserStatus = async (userId, status) => {
    if (!token) return false;

    try {
      const res = await fetch(`${BASE_URL}/subscribed-users/${userId}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });

      const data = await res.json();

      if (res.ok) {
        setUsers((prev) =>
          prev.map((u) => (u.id === userId ? { ...u, status: data.status || status } : u))
        );
        return true;
      } else {
        console.error(data.message || "Failed to update status");
        return false;
      }
    } catch (error) {
      console.error("Error updating status:", error);
      return false;
    }
  };

  return (
    <SubscribedUserContext.Provider value={{ users, loading, fetchUsers, updateUserStatus }}>
      {children}
    </SubscribedUserContext.Provider>
  );
};
